// extracted by mini-css-extract-plugin
export default {"loaderContainer":"layout_loaderContainer__Fn3-Z","loader":"layout_loader__JIPvI","bottomNavbar":"layout_bottomNavbar__Iw27g"};